import React__default from 'react';
import cn from 'classnames';
import { useTranslate } from '@awardit/react-use-translate';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Button } from '../Button/index.js';
import { Link } from 'react-router-dom';
import styles from 'ui-components/AdventCalendar.scss';

var OpenDoor = function OpenDoor(_ref) {
  var _cn;
  var variant = _ref.variant,
    buttonVariant = _ref.buttonVariant,
    day = _ref.day,
    _ref$category = _ref.category,
    name = _ref$category.name,
    url = _ref$category.url,
    image = _ref$category.image,
    shortDescription = _ref$category.shortDescription,
    description = _ref$category.description;
  var t = useTranslate();
  return /*#__PURE__*/React__default.createElement(Link, {
    className: cn(styles.door, styles.open, (_cn = {}, _cn[styles["variant__" + (variant || "")]] = variant !== null, _cn)),
    to: {
      pathname: url,
      state: {
        hint: {
          type: "category",
          category: {
            name: name,
            url: url,
            image: image,
            description: description
          }
        }
      }
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.doorHoverDim
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles.doorContent
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.doorText
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.doorTextBackdrop
  }), /*#__PURE__*/React__default.createElement("h3", null, t("ADVENT_CALENDAR.DOOR_TITLE", {
    day: day
  })), /*#__PURE__*/React__default.createElement("h2", null, name), /*#__PURE__*/React__default.createElement("p", null, shortDescription)), /*#__PURE__*/React__default.createElement(Button, {
    elem: "span",
    className: styles.button,
    variant: buttonVariant
  }, t("ADVENT_CALENDAR.OPEN_DOOR", {
    day: day
  }))), /*#__PURE__*/React__default.createElement("img", {
    className: styles.img,
    src: image == null ? void 0 : image.x1,
    alt: t("ADVENT_CALENDAR.OPEN_DOOR_ALT")
  }));
};
var LockedDoor = function LockedDoor(_ref2) {
  var image = _ref2.image,
    day = _ref2.day;
  var t = useTranslate();
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.door, styles.closed)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.doorContent
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.doorText
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.doorTextBackdrop
  }), /*#__PURE__*/React__default.createElement("h3", null, t("ADVENT_CALENDAR.DOOR_TITLE", {
    day: day
  })))), /*#__PURE__*/React__default.createElement("img", {
    className: styles.img,
    src: image == null ? void 0 : image.x1,
    alt: t("ADVENT_CALENDAR.CLOSED_DOOR_ALT")
  }));
};
var AdventCalendarDoors = function AdventCalendarDoors(_ref3) {
  var doors = _ref3.doors,
    closedSlot = _ref3.closedSlot,
    _ref3$buttonVariant = _ref3.buttonVariant,
    buttonVariant = _ref3$buttonVariant === void 0 ? "primary" : _ref3$buttonVariant;
  var openDays = [];
  doors.forEach(function (day) {
    if (day.__typename !== "AdventCalendarDoorLocked") {
      openDays.push(day);
    }
  });
  if (openDays.length === 0) {
    return closedSlot;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.block
  }, openDays.length > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: styles.container
  }, doors.map(function (x) {
    return /*#__PURE__*/React__default.createElement("div", {
      key: x.day,
      className: styles.column
    }, x.__typename === "AdventCalendarDoorOpen" && /*#__PURE__*/React__default.createElement(OpenDoor, _extends({}, x, {
      buttonVariant: buttonVariant
    })), x.__typename === "AdventCalendarDoorToday" && /*#__PURE__*/React__default.createElement(OpenDoor, _extends({}, x, {
      buttonVariant: buttonVariant
    })), x.__typename === "AdventCalendarDoorLocked" && /*#__PURE__*/React__default.createElement(LockedDoor, x));
  })));
};

export { AdventCalendarDoors };
//# sourceMappingURL=index.js.map
